import { render, staticRenderFns } from "./ParticularSummary.vue?vue&type=template&id=5de3cda4"
import script from "./ParticularSummary.vue?vue&type=script&lang=js"
export * from "./ParticularSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports